import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import moment from 'moment-timezone';

import { TranslatePipe } from '@recruitee/i18n';
import {
  ConnectedOverlayDirective,
  DatePickerDirection,
  IconComponent,
  IconColorDirective,
  ButtonComponent,
  DatePickerComponent,
  DropdownComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-schedule-date-dropdown',
  templateUrl: 'schedule-date-dropdown.component.html',
  styleUrls: ['./schedule-date-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DropdownComponent,
    DatePickerComponent,
    ButtonComponent,
    IconColorDirective,
    IconComponent,
    TranslatePipe,
  ],
})
export class ScheduleDateDropdownComponent {
  @Input() public direction: DatePickerDirection = 'today-future';
  @Input() public currentDate: string;
  @Input() public dropdownRef: ConnectedOverlayDirective;
  @Input() public closeOnDateChange: boolean = false;
  @Input() public showClear?: boolean = false;
  @Input() public useYearNav: boolean = false;
  @Input() public blackoutDates: ((date: moment.Moment) => boolean) | null = null;

  @Output() public dateChange: EventEmitter<moment.Moment> = new EventEmitter();

  public date: string;

  public ngOnChanges(changes: SimpleChanges): void {
    const currentDate = changes.currentDate && changes.currentDate.currentValue;

    if (currentDate) {
      this.date = moment(currentDate, 'DD MMM YYYY').format('YYYY-MM-DD');
    }
  }

  public onDateChange(date: string): void {
    this.dateChange.emit(date?.length ? moment(date, 'YYYY-MM-DD') : undefined);
    if (this.closeOnDateChange) {
      this.dropdownRef.open = false;
    }
  }
}
